<div class="modal-size" role="dialog">
  <gstar-header-modal [id]="modalId()" [title]="title()" />
  <gstar-body-modal>
    <p>
      {{ content() }}
    </p>
    <form class="pt-2" [formGroup]="securityForm">
      <gstar-datepicker
        [label]="placeHolderSecurityDateField()"
        attachedDOM="body"
        [isRequired]="true"
        formControlName="securityDateField" />
      @if (securityDateField.errors?.['dateRange']) {
        <div class="ap-field-validation-error">
          {{ incorrectDateErrorMessagge }}
        </div>
      }
    </form>
  </gstar-body-modal>
  <gstar-footer-modal
    [id]="modalId()"
    [isEnabled]="hasSelectedDate() && securityForm.valid"
    (confirmEvent)="confirm()" />
</div>
